module.exports = __webpack_public_path__ + "img/fastpitch.be36e4e1.svg";